import { memo } from 'react';
import { Grid, Typography } from '@mui/material';
import { IPageMainTitleProps } from 'interface/cmn/commonInfo';

function PageMainTitle({ title, fontSize = 20, fontWeight = 700 }: IPageMainTitleProps): JSX.Element {
  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item>
        <Typography
          sx={{
            color: '#000',
            fontSize,
            fontWeight,
          }}
        >
          {title}
        </Typography>
      </Grid>
      <Grid item />
    </Grid>
  );
}

export default memo(PageMainTitle);
